var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemelistIconLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 10",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.00523 5C3.4138 5 2.9338 4.52021 2.9338 3.929C2.9338 3.33714 3.4138 2.85714 4.00523 2.85714C4.59666 2.85714 5.07666 3.33714 5.07666 3.929C5.07666 4.52021 4.59666 5 4.00523 5ZM7.31956 5.87C7.72143 5.25705 7.9338 4.54955 7.9338 3.82341C7.93357 1.71614 6.17149 0.000909091 4.00593 0H4.00569C1.84059 0.000909091 0.0780467 1.71614 0.0766602 3.82341C0.0766602 4.5475 0.289034 5.255 0.703152 5.88682L4.00546 10L7.31956 5.87Z"
  })));
}
export default SvgThemelistIconLocation;